<script setup>
/**
 * FormControlTagsTagUsage
 * Fetches and displays where a specific tag is being used across
 * different system components.
 */
import { ref, computed, onMounted, getCurrentInstance, watch } from 'vue';
import FormControlTagsUsageComponent from './FormControlTagsUsageComponent.vue';

const props = defineProps({
    formId: {
        type: String,
        required: true
    },
});

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- State ---

const componentItemIds = ref({});

// --- Computed ---

const tagId = computed(() => store.state[props.formId]?.id);

// --- Methods ---

const fetchUsageData = async () => {
    if (!tagId.value) return;

    try {
        const response = await store.dispatch('request/get', {
            url: 'api/tags/usage',
            params: {
                tagId: tagId.value
            }
        });

        componentItemIds.value = response.data.componentItemIds || {};
    } catch (error) {
        console.error('Failed to fetch tag usage data:', error);
        componentItemIds.value = {};
    }
};

// --- Lifecycle & Watchers ---

onMounted(() => {
    fetchUsageData();
});

/**
 * Watch the tagId. If the user navigates between different tags
 * while the form is open, we need to re-fetch the usage mapping.
 */
watch(tagId, (newId) => {
    if (newId) fetchUsageData();
});
</script>

<template>
    <div>
        <FormControlTagsUsageComponent
            v-for="(itemIds, componentId) in componentItemIds"
            :key="componentId"
            :component-id="Number(componentId)"
            :item-ids="itemIds"
            :tag-id="tagId"
        />
    </div>
</template>